import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface UserContentProps extends React.HTMLAttributes<HTMLElement> {
  /** Element to render — defaults to span. Use heading tags for titles. */
  as?: React.ElementType;
  children: React.ReactNode;
}

/**
 * Semantic wrapper for user-authored TITLES (contract §8): serif voice,
 * weight 500, 16px floor. Callers may raise the size via className; the
 * serif stack and weight are the invariant. Never apply serif via element
 * rules — this wrapper is the only sanctioned path.
 */
export function UserContent({ as: Tag = 'span', className, children, ...rest }: UserContentProps) {
  return (
    <Tag className={twMerge('m-0 font-serif font-medium text-base', className)} {...rest}>
      {children}
    </Tag>
  );
}
